<template>
  <v-container fluid class="webConWork-management mt-4 px-1">
    <v-row>

<!--      <template>
        <v-row justify="center">
          <v-dialog
              v-model="dialog_upload"
              width="1250px"
          >
            <v-card>

              <UploadManagement
                  id="Conpage_UploadManagement">

              </UploadManagement>

            </v-card>


          </v-dialog>
        </v-row>
      </template>-->


      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการผลงาน/ผลงานวิชาการ</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + webConWorks.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>




              <!--              <v-text-field-->
              <!--                  v-model="search"-->
              <!--                  append-icon="mdi-magnify"-->
              <!--                  label="ค้นหา (Search)"-->
              <!--                  single-line-->
              <!--                  hide-details-->
              <!--                  class="search"-->
              <!--              ></v-text-field>-->
            </div>
          </v-card-title>

          <v-card-title class="pa-5 pb-0">
            <v-row align="center">

              <v-col class="d-flex" cols="12" sm="2">

                <v-select
                    @change="searchData"
                    v-model="search_data.work_type"
                    :items="work_type_combo"
                    item-text="parameter_th"
                    item-value="parameter_value"
                    label="ประเภทผลงาน"
                    clearable=""

                ></v-select>


              </v-col>



              <v-col class="d-flex" cols="12" sm="2">

                <v-select
                    @change="searchData"
                    v-model="search_data.work_type_detail"
                    :items="status_check_combo"
                    item-text="v_name"
                    item-value="v_value"
                    label="สถานะ"
                    clearable=""
                ></v-select>


              </v-col>
              <v-col class="d-flex" cols="12" sm="2">

                <v-select
                    @change="searchData"
                    v-model="search_data.user_name"
                    :items="work_users_combo"
                    item-text="full_name_th"
                    item-value="user_name"
                    label="บุคลากร"
                    clearable=""

                ></v-select>


              </v-col>

              <v-col class="d-flex" cols="12" sm="3">

                <v-select
                    @change="searchData"
                    v-model="search_data.work_type_detail"
                    :items="work_type_detail_combo"
                    item-text="parameter_th"
                    item-value="parameter_value"
                    label="ระดับผลงาน"
                    clearable=""
                    class="selectLong"
                ></v-select>


              </v-col>

              <v-col class="d-flex" cols="12" sm="3">
                <v-text-field
                    append-icon="mdi-magnify"
                    class="search"
                    v-model="search"
                    label="ค้นหา (Search)"
                ></v-text-field>
              </v-col>




            </v-row>

          </v-card-title>


          <v-card>


          </v-card>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items="webConWorks"
                :search="search"
                sort-by="work_id">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>




                  <v-btn style="margin-left: 10px;"
                         color="blue-grey"
                         class="ma-2 white--text"
                      @click="downloadReport('xlsx')"
                  >ดาวน์โหลด Excel
                    <v-icon
                        right
                        dark
                    >
                      mdi-file-excel
                    </v-icon>
                  </v-btn>

                  <v-btn style="margin-left: 10px;"
                         color="blue-grey"
                         class="ma-2 white--text"
                         @click="downloadReport('pdf')"
                  >พิมพ์ข้อมูล
                    <v-icon
                        right
                        dark
                    >
                      mdi-printer
                    </v-icon>
                  </v-btn>


                </template>


              </template>

              <template v-slot:item.news_h_image_th="{ item }">

                <v-avatar tile>
                  <img
                      :src="baseURLStorage+item.news_h_image_th"
                      :alt="item.news_title_th"
                  >
                </v-avatar>
                <v-avatar tile v-if="item.switch_lang=='Y'">
                  <img
                      :src="baseURLStorage+item.news_h_image_en"
                      :alt="item.news_title_th"
                  >
                </v-avatar>


              </template>


              <template v-slot:item.switch_lang="{ item }">
                <v-btn
                    fab
                    x-small
                    depressed
                    color=""
                >TH
                </v-btn>
                <v-btn v-if="item.switch_lang=='Y'"
                       fab
                       x-small
                       depressed
                       color=""
                >EN
                </v-btn>

              </template>

              <template v-slot:item.user_name="{ item }">
                <span>{{ item.full_name_th}}</span>

              </template>

              <template v-slot:item.work_title_th="{ item }">
                <span>{{ item.work_title_th}}</span>
                <sup>{{ item.work_owner_name_th }}</sup><br>
                <span>║ {{ item.work_public_title_th}}</span>

              </template>


              <template v-slot:item.work_type="{ item }">
                <span>{{ item.parameter_th }}</span>
                <sup>{{ item.work_public_inter }}</sup>
              </template>

              <template v-slot:item.work_public_month_year="{ item }">
                <span> {{ dataFormatter.dateFormatterTH(item.work_public_month_year, 4) }}</span>
                <sup>{{ item.MNumYear }}</sup>

              </template>



              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>

              <template v-slot:item.status_check="{ item }">
                <span v-if="item.status_check == 'W'" class="v-chip theme--light v-size--small warning"><span
                    class="v-chip__content">{{ item.status_check_text }}</span></span>

                <span v-else-if="item.status_check == 'S'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">{{ item.status_check_text }}</span></span>

                <span v-else-if="item.status_check == 'C'" class="v-chip theme--light v-size--small secondary"><span
                    class="v-chip__content">{{ item.status_check_text }}</span></span>

                <span v-else-if="item.status_check == 'E'" class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">{{ item.status_check_text }}</span></span>


              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

            <span> xx {{
                currentUser.user_name
              }}</span>


          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="3">

                  <v-select
                      v-model="editForm.work_type"
                      :rules="editForm.textReqRules"
                      :items="work_type_combo"
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ประเภทผลงาน"
                      clearable=""
                      required
                  ></v-select>

                </v-col>


                <v-col class="d-flex" cols="12" sm="3">
                  <v-radio-group v-model="editForm.work_public_type">
                    <template v-slot:label>
                      <div>รูปแบบ <strong>การเผยแพร่/ตีพิมพ์</strong></div>
                    </template>
                    <v-radio value="ตีพิมพ์">
                      <template v-slot:label>
                        <div>ผ่านการ <strong class="success--text">ตีพิมพ์</strong></div>
                      </template>
                    </v-radio>
                    <v-radio value="ประชุมวิชาการ (Full Paper)">
                      <template v-slot:label>
                        <div>ประชุมวิชาการ <strong class="primary--text">(Full Paper)</strong></div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>

                <v-col class="d-flex" cols="12" sm="3">
                  <v-radio-group v-model="editForm.work_public_inter">
                    <template v-slot:label>
                      <div>ระดับ <strong>การนำเสนอ</strong></div>
                    </template>
                    <v-radio value="ระดับชาติ">
                      <template v-slot:label>
                        <div>ระดับ <strong class="success--text">ระดับชาติ </strong></div>
                      </template>
                    </v-radio>
                    <v-radio value="ระดับนานาชาติ">
                      <template v-slot:label>
                        <div>ระดับ <strong class="primary--text">นานาชาติ</strong></div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>


                <v-col class="d-flex" cols="12" sm="3">

                  <v-text-field
                      v-model="editForm.work_public_base"
                      :rules="editForm.textReqRules"
                      label="ฐาน"
                      hint="เช่น Q1/TCI1 หากไม่มีใส่ -"
                      persistent-hint
                      required

                  ></v-text-field>

                </v-col>

              </v-row>

              <v-row align="center">
                <v-col class="d-flex" cols="12" sm="12">

                  <v-select
                      v-model="editForm.work_type_detail"
                      :rules="editForm.textReqRules"
                      :items="work_type_detail_combo"
                      item-text="parameter_th"
                      item-value="parameter_value"
                      label="ระดับคุณภาพผลงานทางวิชาการ"
                      clearable=""
                      required
                  ></v-select>

                </v-col>

              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                      v-model="editForm.work_owner_name_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อเจ้าของผลงาน (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-text-field
                      v-model="editForm.work_owner_name_en"
                      :rules="editForm.textReqRules"
                      label="ชื่อเจ้าของผลงาน (EN)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="6">

                  <v-textarea
                      rows="2"
                      v-model="editForm.work_title_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อผลงาน (TH)"
                      required
                  ></v-textarea>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-textarea
                      rows="2"
                      v-model="editForm.work_title_en"
                      :rules="editForm.textReqRules"
                      label="ชื่อผลงาน (EN)"
                      required
                  ></v-textarea>

                </v-col>

              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="6">

                  <v-textarea
                      rows="2"
                      v-model="editForm.work_public_title_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อวารสาร/การประชุมทางวิชาการ (TH)"
                      required
                  ></v-textarea>
                </v-col>

                <v-col class="d-flex" cols="12" sm="6">
                  <v-textarea
                      rows="2"
                      v-model="editForm.work_public_title_en"
                      :rules="editForm.textReqRules"
                      label="ชื่อวารสาร/การประชุมทางวิชาการ (EN)"
                      required
                  ></v-textarea>

                </v-col>

              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">

                  <v-text-field
                      v-model="editForm.work_weight"
                      :rules="editForm.textReqRules.concat(editForm.numRules).concat(
                          [ v => v >= 1 || 'ต่ำสุดคือ 1',
                            v => v <= 100 || 'สูงสุดคือ 100',
                          ]
                      )"
                      label="สัดส่วนดำเนินงาน(%)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="2">

                  <v-text-field
                      v-model="editForm.work_public_year"
                      :rules="editForm.textReqRules"
                      label="ปีที่"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="2">

                  <v-text-field
                      v-model="editForm.work_public_no"
                      :rules="editForm.textReqRules"
                      label="ฉบับที่"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="3">

                  <v-text-field
                      v-model="editForm.work_public_number"
                      :rules="editForm.textReqRules"
                      label="หน้าที่เผยแพร่"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="3">

                  <v-text-field
                      v-model="editForm.work_public_isbn"
                      label="ISBN/ISSN/DOI"
                  ></v-text-field>
                </v-col>


              </v-row>


              <v-row align="center">



                <v-col class="d-flex" cols="12" sm="2">


                  <v-menu
                      v-model="menu2"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="dateFormatted"
                          :rules="editForm.textReqRules"
                          label="วันที่เผยแพร่"
                          hint="วัน/เดือน/พ.ศ."
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date"
                        :rules="editForm.textReqRules"
                        :first-day-of-week="1"
                        locale="th"
                        @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <v-col class="d-flex" cols="12" sm="2">

                  <!--                  <v-text-field-->
                  <!--                      v-model="editForm.work_public_month_year"-->
                  <!--                      :rules="editForm.textReqRules"-->
                  <!--                      label="เดือน/ปีที่ตีพิมพ์ (พ.ศ.)"-->
                  <!--                      required-->
                  <!--                  ></v-text-field>-->

                  <v-menu
                      v-model="menu3"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="datemonthFormatted"
                          :rules="editForm.textReqRules"
                          label="เดือน/ปีที่ตีพิมพ์ (พ.ศ.)"
                          hint="เดือน/พ.ศ."
                          persistent-hint
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="datemonth"
                        :rules="editForm.textReqRules"
                        type="month"
                        locale="th"
                        @input="menu3 = false"
                    ></v-date-picker>
                  </v-menu>


                </v-col>

                <v-col class="d-flex" cols="12" sm="4">

                  <v-text-field
                      v-model="editForm.work_public_place"
                      :rules="editForm.textReqRules"
                      label="สถานที่เผยแพร่"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="2">

                  <v-text-field
                      v-model="editForm.work_public_province"
                      :rules="editForm.textReqRules"
                      label="จังหวัด"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="2">

                  <v-text-field
                      v-model="editForm.work_public_country"
                      :rules="editForm.textReqRules"
                      label="ประเทศ"
                      required
                  ></v-text-field>
                </v-col>


              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="2">

                  <v-switch
                      v-model="editForm.status_link"
                      inset
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="อัพโหลดไฟล์ | URL"
                      required
                  ></v-switch>

                </v-col>

                <v-col class="d-flex" cols="12" sm="10" v-if="state=='addForm'">
                  <v-file-input
                      v-if="editForm.status_link=='Y'"
                      v-model="editForm.avatarFileFi"
                      show-size
                      chips
                      :rules="editForm.textReqRules.concat(editForm.fileRules)"
                      placeholder="อัพโหลดไฟล์"
                      prepend-icon="mdi-file"
                      label="อัพโหลดไฟล์"
                  ></v-file-input>

                  <v-text-field
                      v-if="editForm.status_link=='N'"
                      v-model="editForm.work_h_url"
                      :rules="editForm.textReqRules"
                      label="URL ของไฟล์"
                      required
                  ></v-text-field>

                </v-col>
                <v-col class="d-flex" cols="12" sm="10" v-if="state=='editForm'">


                  <div class="text-center" v-if="editForm.status_link=='Y' && !editForm.avatarFileFiOld==false">
                    <v-chip
                        link
                        class="ma-4"
                        color="default"
                    >
                      <v-icon left>mdi-file</v-icon>
                      <a :href="baseURLStorage+editForm.avatarFileFiOld" target="_blank">
                        ไฟล์อัพโหลดเดิม </a>
                    </v-chip>
                  </div>


                  <v-file-input
                      v-if="editForm.status_link=='Y'"
                      v-model="editForm.avatarFileFi"
                      show-size
                      chips
                      :rules="editForm.fileRules"
                      placeholder="อัพโหลดไฟล์ใหม่"
                      prepend-icon="mdi-file"
                      label="อัพโหลดไฟล์ใหม่"
                  ></v-file-input>


                  <v-text-field
                      v-if="editForm.status_link=='N'"
                      v-model="editForm.work_h_url"
                      :rules="editForm.textReqRules"
                      label="URL ของไฟล์"
                      required
                  ></v-text-field>

                </v-col>


              </v-row>


              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="4">

                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>

                </v-col>

              </v-row>


              <v-row align="center" v-if="work_users_combo.length>1">
                <v-chip

                    color="secondary"
                    class="ma-2"
                >
                  สำหรับเจ้าหน้าที่/ผู้ดูแลระบบ
                </v-chip>

                <v-col class="d-flex" cols="12" sm="3">

                  <v-select
                      v-model="editForm.user_name"
                      :rules="editForm.textReqRules"
                      :items="work_users_combo"
                      item-text="full_name_th"
                      item-value="user_name"
                      label="ข้อมูลบุคลากร"
                      clearable=""
                      required
                  ></v-select>


                </v-col>

                <v-col class="d-flex" cols="12" sm="3">

                  <v-select
                      v-model="editForm.status_check"
                      :rules="editForm.textReqRules"
                      :items="status_check_combo"
                      item-text="v_name"
                      item-value="v_value"
                      label="สถานะเอกสาร"
                      clearable=""
                      required
                  ></v-select>

                </v-col>
              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapMutations, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
// import Editor from '@tinymce/tinymce-vue';
// import UploadManagement from '@/pages/WebContent/UploadManagement/UploadManagement';
import axios from "axios";
import dataFormatter from "@/use/dataFormatter";

export default {
  name: 'ConWorkManagement',
  data() {
    return {
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      modal: false,
      menu2: false,
      menu3: false,
      datemonth: (new Date().toISOString().substr(0, 7)),
      datemonthFormatted: this.formatDateMonth((new Date().toISOString().substr(0, 7))),

      state: 'index',
      tiny: config.tiny,
      baseURLApi: config.baseURLApi,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      dialog_upload: false,
      search: '',
      search_data: {
        work_type: "",
        work_type_detail: "",
        status_check:"",
        user_name:"",
      },
      selected: [],
      headers: [
        {
          text: 'บุคลากร',
          align: 'start',
          value: 'user_name',
          width:'10%'
        },
        {text: 'ประเภทผลงาน', value: 'work_type',width:'10%'},
        {text: 'ผลงาน', value: 'work_title_th',width:'45%'},
        {text: 'เดือนปีที่ตีพิมพ์', value: 'work_public_month_year',width:'10%'},
        {text: 'ใช้งาน', value: 'active',width:'5%'},
        {text: 'สถานะ', value: 'status_check',width:'5%'},
        {text: 'การจัดการ', value: 'api', sortable: false,width:'15%'},
      ],
      status_check_combo: [
        {v_value: 'W', v_name: 'อยู่ระหว่างตรวจสอบ'},
        {v_value: 'S', v_name: 'ข้อมูลถูกต้อง'},
        {v_value: 'C', v_name: 'ข้อมูลไม่ถูกต้อง'},
        {v_value: 'E', v_name: 'ยกเลิก'},
      ],
      work_type_combo: [],
      work_type_detail_combo: [],
      work_users_combo: [],
      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {},
    }
  },
  components: {
    // 'editor': Editor, // <- Important part
    // UploadManagement
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('web_con_works', ['webConWorks', "isReceiving", "isDeleting", "idToDelete", "webConWorkMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
    dataFormatter() {
      return dataFormatter;
    },

    //Date Picker Format
    computedDateFormatted() {
      return this.formatDate(this.date)
    },

    computedDateMonthFormatted() {
      return this.formatDateMonth(this.datemonth)
    },
    //getDataUserLogin

    ...mapState('auth', {
      currentUser: (state) => state.currentUser,
    }),
    ...mapState({
      data: (state) => state.usersForm.data,
    }),
  },
  async beforeMount() {

    //getDataUserLogin //cannot remember write for use
/*    try {

      const { user } = JSON.parse(localStorage.getItem('user'));
      const id = user.id;

      if (id) {
        this.id = id;
        await this.getData(id);
        this.formatData();
      }
    } catch (e) {
      this.showSnackbar(e);
    }*/
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    webConWorkMessage() {

      if (this.webConWorkMessage !== '') {
        this.notification = this.webConWorkMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {

          this.addSuccessNotification();

        }
        this.close();
      }
    },

    //Date Picker Format
    date() {
      this.dateFormatted = this.formatDate(this.date)
    },
    datemonth() {
      this.datemonthFormatted = this.formatDateMonth(this.datemonth)
    },
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getWebConWorksRequest(this.search_data);
    this.getDcParamCombobox();
    this.resetValue();
  },
  methods: {

    //getDataUserLogin
    ...mapMutations({
      showSnackbar: 'snackbar/showSnackbar',
    }),
    ...mapActions({
      getData: 'usersForm/getData',
    }),

    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('web_con_works',
        [
          "getWebConWorksRequest",
          "deleteWebConWorkRequest",
          "updateWebConWorkRequest",
          "createWebConWorkRequest"
        ]
    ),
    formatData() {
      // this.fname_th = this.data.fname_th;
      // this.lname_th = this.data.lname_th;
      // this.user_platform_reg = this.data.user_platform_reg;
      // this.email = this.data.email;
      // this.role = this.data.role;
      // this.avatar = this.data.avatar;
    },
    resetValue() {


      this.editForm = {}
      this.editForm = {
        valid: true,
        numRules: validateRules.numRules,
        textReqRules: validateRules.textReqRules,
        imageRules: validateRules.fileSingleRules(3),
        fileRules: validateRules.fileSingleRules(100),
        work_id: null,
        work_public_inter: 'ระดับชาติ',
        work_public_type: 'ตีพิมพ์',
        work_public_base: '-',

        /*
                work_type: '',
                work_type_detail: '',
                work_owner_name_th: '',
                work_owner_name_en: '',
                work_title_th: '',
                work_title_en: '',
                work_public_title_th: '',
                work_public_title_en: '',
                work_weight: '',
                work_public_year: '',
                work_public_no: '',
                work_public_number: '',
                work_public_isbn: '',
                work_public_date: '',
                work_public_month_year: '',
                work_public_place: '',
                work_public_province: '',
                work_public_country: '',*/
        status_link: 'Y',
        work_h_url: '#',
        active: 'Y',
        status_check: 'W',
        avatarFileFi: null,
        avatarFileFiOld: null,
        user_name :(this.currentUser !=null?this.currentUser.user_name:'')
      }


    },
    async getDcParamCombobox() {

      try {

        await axios.post(config.baseURLApi + '/combo_dc_param/' + 'WEB' + '/' + 'WORKS_TYPE', '', {
          headers: {},
        }).then(res => {
          this.work_type_combo = res.data;
        });

        await axios.post(config.baseURLApi + '/combo_dc_param/' + 'WEB' + '/' + 'WORKS_TYPE_DETAIL', '', {
          headers: {},
        }).then(res => {
          this.work_type_detail_combo = res.data;
        });

        const formData = new FormData();
        formData.append('role_group', 'web1');
        formData.append('role_page', '/web/content_work');
        formData.append('check_role', '');

        await axios.post(config.baseURLApi + '/combo/' + 'usersActiveOwn', formData, {
          headers: {},
        }).then(res => {
          this.work_users_combo = res.data;
        });

      } catch (e) {
        this.showSnackbar(e);
      }


    },


    addItem() {
      this.editedIndex = -1 //index = -1 add
      this.resetValue();
      this.editForm.active = 'Y';
      this.editForm.work_public_inter = 'ระดับชาติ'
      this.editForm.work_public_type = 'ตีพิมพ์'
      this.editForm.status_link = 'Y'
      this.editForm.status_check = 'W'
      this.editForm.work_h_url = '#';
      this.editForm.user_name = this.currentUser.user_name;
      this.state = 'addForm';


      console.log('ต้องกำหนดค่า user_name ของคนที่ล็อกอินอยู่  '+this.currentUser.user_name);

    },
    editItem(item) {
      this.resetValue();
      this.editedIndex = this.webConWorks.indexOf(item) //index ของ row ที่จะแก้ไข

      this.date =   item.work_public_date;
      this.dateFormatted = this.formatDate(item.work_public_date);

      this.datemonth =   item.work_public_month_year;
      this.datemonthFormatted = this.formatDateMonth(item.work_public_month_year);

      this.editForm.work_id= item.work_id;
      this.editForm.user_name= item.user_name;
      this.editForm.work_type= item.work_type;
      this.editForm.work_type_detail= item.work_type_detail;
      this.editForm.work_public_inter= item.work_public_inter;
      this.editForm.work_public_type= item.work_public_type;
      this.editForm.work_public_base= item.work_public_base;
      this.editForm.work_owner_name_th= item.work_owner_name_th;
      this.editForm.work_owner_name_en= item.work_owner_name_en;
      this.editForm.work_title_th= item.work_title_th;
      this.editForm.work_title_en= item.work_title_en;
      this.editForm.work_public_title_th= item.work_public_title_th;
      this.editForm.work_public_title_en= item.work_public_title_en;
      this.editForm.work_weight= item.work_weight;
      this.editForm.work_public_year= item.work_public_year;
      this.editForm.work_public_no= item.work_public_no;
      this.editForm.work_public_number= item.work_public_number;
      this.editForm.work_public_isbn= item.work_public_isbn;
      this.editForm.work_public_date= item.work_public_date;
      this.editForm.work_public_month_year= item.work_public_month_year;
      this.editForm.work_public_place= item.work_public_place;
      this.editForm.work_public_province= item.work_public_province;
      this.editForm.work_public_country= item.work_public_country;
      this.editForm.status_link= item.status_link;
      this.editForm.work_h_file= item.work_h_file;
      this.editForm.avatarFileFiOld = item.work_h_file;
      this.editForm.work_h_url= item.work_h_url;
      this.editForm.status_check= item.status_check;
      this.editForm.active = item.active;
      this.editForm.status_check_text = item.status_check_text;
      this.editForm.MNumYear = item.MNumYear;
      this.editForm.NumYear = item.NumYear;
      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteWebConWorkRequest({work_id: item.work_id})

    },
    close() {

      if (this.errorMessage == false || this.webConWorkMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    save() {

      this.editForm.work_public_date = this.date;
      this.editForm.work_public_month_year = this.datemonth;

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.webConWorks[this.editedIndex], this.editForm)
            :
            this.updateWebConWorkRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.webConWorks.push(this.editForm)
            :
            this.createWebConWorkRequest(this.editForm)
      }


    },
    downloadReport(extension){

      var username = (this.search_data.user_name==""||this.search_data.user_name==null)?this.currentUser.user_name:this.search_data.user_name;
      var url = config.baseURLReport + '/master_r_001/' +extension+ '/'+ username;
      window.open(url);
    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    async reset() {
      await this.$refs.form.reset()
      this.resetValue()
    },
    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    showUploads() {
      this.dialog_upload = true;
    },

    //Date Picker Format

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${(year) * 1 + 543}`
    },
    formatDateMonth(date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${(year) * 1 + 543}`
    },

    parseDate(date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    parseDateMonth(date) {
      if (!date) return null
      const [month, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}`
    },
    searchData() {
      this.getWebConWorksRequest(this.search_data);
    },



  },
}
</script>

<style src="./ConWorkManagement.scss" lang="scss"/>
